module.exports = __webpack_public_path__ + "img/bos_logo.aefc1a7d.svg";